interface BrupaLogoProps {
  color?: string;
  height?: number;
}

export function BrupaLogo({ color = "#2d2d2d", height = 40 }: BrupaLogoProps) {
  const brupaSize = height * 0.72;
  const subSize = height * 0.22;
  const gap = height * 0.04;

  return (
    <div style={{ display: "inline-flex", flexDirection: "column", gap, lineHeight: 1 }}>
      <div
        style={{
          fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
          fontWeight: 900,
          fontSize: brupaSize,
          color,
          letterSpacing: "0.03em",
          lineHeight: 1,
        }}
      >
        BRUPA
      </div>
      <div
        style={{
          fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
          fontWeight: 300,
          fontSize: subSize,
          color,
          letterSpacing: "0.38em",
          lineHeight: 1,
        }}
      >
        FASHION MALL
      </div>
    </div>
  );
}
